/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

// local imports.
import { ApiService } from 'app/services/api.service';
import { ApiResponse } from '@core/models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class UtilsApiService {
  constructor(private apiService: ApiService, private http: HttpClient) {}

  getUsaStates(): Observable<ApiResponse> {
    return this.http
      .get<ApiResponse>(`${this.apiService.utils}/countries-with-states`)
      .pipe(catchError((error: HttpErrorResponse) => observableThrowError(error)));
  }
}
